<template>
    <div class="container fluid">
        <div class="row justify-content-center">
            <div class="how-to-earn-points-container col-8 col-md-6" v-on:click="toggleShowHowToEarnPointsModal()">
        <span class="how-to-earn-points-text">HOW DO I EARN POINTS?
          <BIconChevronDown class="chev-down-white"/>
        </span>
            </div>
        </div>
        <HowToEarnPointsModal v-if="showHowToEarnPointsModal"></HowToEarnPointsModal>
        <div class="text-box">
            <p class="description-text">Tap the team you think will WIN!</p>
        </div>
        <hr class="line-break">
        <div v-for="(fixture, index) in roundFixtures" :key="index" class="match-box">
            <div class="date-time col-11 mb-2">
                <p class="date-text">T20 | {{ formatDate(fixture.StartDate) }}</p>
            </div>
            <div v-if="fixture.FixtureStarted === 0" class="predictions-closed-box col-11">
                <p class="predictions-closed-text">Predictions for this match are closed!</p>
            </div>
            <div class="flex-column">
                <div class="cricket-match">
                    <div class="team-img-box" v-bind:style="windowWidth > 900 ? 'width: 250px' : ''">
                        <img v-if="getTeamLogo(fixture.Team1Name)" :src="getTeamLogo(fixture.Team1Name)" alt=""
                             class="team-logo">
                        <div v-if="!getTeamLogo(fixture.Team1Name)" class="generic-logo-team-box">
                            <img class="generic-logo" :src="getGenericLogo()" alt="">
                            <p class="generic-team-text"> {{fixture.Team1Name}}</p>
                        </div>
                        <div class="prediction-box"  v-bind:style="windowWidth > 900 ? 'width: 250px' : ''" v-if="!hasWinningTeamPredicted(fixture, fixture.Team1Name)"
                             v-on:click="onClickToPic(index, fixture.Team1Name)">
                            <p v-if="fixture.predictedWinningTeam !== fixture.Team2Name" class="cick-to-pick-text">Click
                                to pick</p>
                            <p v-if="fixture.predictedWinningTeam === fixture.Team2Name" class="to-lose-text">To lose
                            </p>
                        </div>
                        <div class="prediction-box" v-bind:style="windowWidth > 900 ? 'width: 250px' : ''" v-if="fixture.Team1Name === marginPickerSelectedTeamName">
                            <p class="select-margin-text">
                                Select margin</p>
                        </div>
                        <div v-if="hasWinningTeamPredicted(fixture, fixture.Team1Name)" class="prediction-completed-box"  v-bind:style="windowWidth > 900 ? 'width: 250px' : ''"
                             v-on:click="onClickToPic(index, fixture.Team1Name)">
                            <p class="win-margin-text">{{fixture.winMargin}}</p>
                        </div>
                    </div>
                    <div class="vs-text-box">
                        <p class="vs-text">VS</p>
                    </div>
                    <div class="team-img-box" v-bind:style="windowWidth > 900 ? 'width: 250px' : ''">
                        <img v-if="getTeamLogo(fixture.Team2Name)" :src="getTeamLogo(fixture.Team2Name)" alt=""
                             class="team-logo">
                        <div v-if="!getTeamLogo(fixture.Team2Name)" class="generic-logo-team-box">
                            <img class="generic-logo" :src="getGenericLogo()" alt="">
                            <p class="generic-team-text"> {{fixture.Team2Name}}</p>
                        </div>
                        <div v-if="!hasWinningTeamPredicted(fixture, fixture.Team2Name)" class="prediction-box"  v-bind:style="windowWidth > 900 ? 'width: 250px' : ''"
                             v-on:click="onClickToPic(index, fixture.Team2Name)">
                            <p v-if="fixture.predictedWinningTeam !== fixture.Team1Name" class="cick-to-pick-text">Click
                                to pick</p>
                            <p v-if="fixture.predictedWinningTeam === fixture.Team1Name" class="to-lose-text">To lose
                            </p>
                        </div>
                        <div class="prediction-box" v-bind:style="windowWidth > 900 ? 'width: 250px' : ''" v-if="fixture.Team2Name === marginPickerSelectedTeamName">
                            <p v-if="fixture.Team2Name === marginPickerSelectedTeamName" class="select-margin-text">
                                Select margin</p>
                        </div>
                        <div v-if="hasWinningTeamPredicted(fixture, fixture.Team2Name)" class="prediction-completed-box"  v-bind:style="windowWidth > 900 ? 'width: 250px' : ''"
                             v-on:click="onClickToPic(index, fixture.Team2Name)">
                            <p class="win-margin-text">{{fixture.winMargin}}</p>
                        </div>
                    </div>
                </div>
                <div v-if="marginPickerSelectedIndex === index" class="win-margin-selector-box">
                    <div class="win-margin-button" v-on:click="onMarginClicked('Narrow Win', fixture,  index)"><p
                            class="mb-0">
                        Narrow
                        Win</p></div>
                    <div class="win-margin-button" v-on:click="onMarginClicked('Comfortable Win', fixture,  index)"><p
                            class="mb-0">
                        Comfortable win</p></div>
                    <div class="win-margin-button" v-on:click="onMarginClicked('Thrashing', fixture,  index)"><p
                            class="mb-0">
                        Thrashing</p></div>
                </div>
                <hr class="line-break-matche-boxes">
            </div>
        </div>
        <div v-if="isSelectAllPredictionsWarning" class="container justify-content-center mt-3">
            <b class="warning-text">PLEASE SELECT ALL MATCH PREDICTIONS BEFORE CLICKING SUBMIT!</b>
        </div>
        <div class="submit-button-box col-12" v-on:click="enterPrediction()">
            <button class="submit-button"><p class="button-text">Submit
                predictions</p></button>
        </div>
    </div>
</template>

<script>
    import ScorePredictorService from "../../services/scorePredictorService";
    import moment from 'moment'
    import {mapMutations, mapState} from "vuex";
    import {sports} from "../../config/sports";
    import {BIconChevronDown} from 'bootstrap-vue';
    import HowToEarnPointsModal from "@/components/HowToEarnPointsModal";

    export default {
        name: "Predictions",
        components: {BIconChevronDown, HowToEarnPointsModal},
        data() {
            return {
                windowWidth: window.innerWidth,
                roundFixtures: [],
                marginPickerSelectedIndex: undefined,
                marginPickerSelectedTeamName: undefined,
                predictions: [],
                isSelectAllPredictionsWarning: false,
            }
        },
        computed: mapState(['userData', 'selectedSport', 'selectedLeague', 'selectedRound', 'roundPredictions', 'showHowToEarnPointsModal']),

        methods: {
            ...mapMutations(['setPointsScoringBreakdown', 'toggleShowHowToEarnPointsModal', 'clearRoundPredictions']),


            hasWinningTeamPredicted(fixture, winningTeamSelected) {
                if (fixture.predictedWinningTeam) {
                    if (fixture.predictedWinningTeam === winningTeamSelected) return true
                }
            },
            async onMarginClicked(margin, fixture, fixtureIndex) {
                this.roundFixtures[fixtureIndex].predictedWinningTeam = this.marginPickerSelectedTeamName;
                this.roundFixtures[fixtureIndex].winMargin = margin;
                const winMargins = this.setVictoryMargins(margin);
                if (this.predictions.length < 1) {
                    this.predictions.push({
                        msisdn: this.userData.msisdn,
                        roundId: this.selectedRound.RoundID,
                        cricketFixtureId: fixture.CricketFixtureID,
                        eventTypeId: 1,
                        teamId: this.marginPickerSelectedTeamName === fixture.Team1Name ? fixture.Team1 : fixture.Team2,
                        battingWinMargin: winMargins.battingWinMargin,
                        bowlingWinMargin: winMargins.bowlingWinMargin
                    });
                } else {
                    if (this.predictions[fixtureIndex]) {
                        this.predictions[fixtureIndex].msisdn = this.userData.msisdn;
                        this.predictions[fixtureIndex].roundId = this.selectedRound.RoundID;
                        this.predictions[fixtureIndex].cricketFixtureId = fixture.CricketFixtureID;
                        this.predictions[fixtureIndex].eventTypeId = 1;
                        this.predictions[fixtureIndex].teamId = this.marginPickerSelectedTeamName === fixture.Team1Name ? fixture.Team1 : fixture.Team2;
                        this.predictions[fixtureIndex].battingWinMargin = winMargins.battingWinMargin;
                        this.predictions[fixtureIndex].bowlingWinMargin = winMargins.bowlingWinMargin;
                    } else {
                        this.predictions.push({
                            msisdn: this.userData.msisdn,
                            roundId: this.selectedRound.RoundID,
                            cricketFixtureId: fixture.CricketFixtureID,
                            eventTypeId: 1,
                            teamId: this.marginPickerSelectedTeamName === fixture.Team1Name ? fixture.Team1 : fixture.Team2,
                            battingWinMargin: winMargins.battingWinMargin,
                            bowlingWinMargin: winMargins.bowlingWinMargin
                        });
                    }
                }
                this.marginPickerSelectedIndex = undefined;
            },
            setVictoryMargins(margin) {
                switch (margin) {
                    case 'Narrow Win':
                        return {
                            bowlingWinMargin: 0,
                            battingWinMargin: 1,
                        };
                    case 'Comfortable Win':
                        return {
                            bowlingWinMargin: 10,
                            battingWinMargin: 3,
                        };
                    case 'Thrashing':
                        return {
                            bowlingWinMargin: 25,
                            battingWinMargin: 6
                        };
                }
            },
            async enterPrediction() {
                if (this.roundFixtures.length === this.predictions.length) {
                    this.isSelectAllPredictionsWarning = false;
                    await this.predictions.asyncForEach((prediction) => {
                        ScorePredictorService.enterCricketRoundPredictions(prediction)
                    });
                    this.$router.push('view-predictions')
                } else {
                    this.isSelectAllPredictionsWarning = true;
                }
            },
            onClickToPic(fixtureIndex, teamName) {
                if (this.marginPickerSelectedIndex === fixtureIndex) {
                    this.marginPickerSelectedIndex = undefined;
                    this.marginPickerSelectedTeamName = undefined;
                    this.isSelectAllPredictionsWarning = false;
                } else {
                    this.marginPickerSelectedIndex = fixtureIndex;
                    this.marginPickerSelectedTeamName = teamName;
                }
            },
            getTeamLogo(teamName) {
                const teamConfig = sports.get(this.selectedSport).get(this.selectedLeague).get(teamName);
                if (!teamConfig) return undefined;
                if (teamConfig.logo === 'teams/world-cup-t20-cricket/NEEDS-ASSET.png') return undefined;
                else return require(`../../assets/${teamConfig.logo}`)
            },
            getGenericLogo() {
                return require(`../../assets/teams/Champions-League-Teams/generic-logo.png`)
            },
            getWinMarginText(fixture) {
                if (fixture.BowlingWinMargin === 0) return "Narrow Win";
                if (fixture.BowlingWinMargin === 10) return "Comfortable Win";
                if (fixture.BowlingWinMargin === 25) return "Thrashing";
            },
            formatDate(date) {
                return moment(date).format('LLLL')
            },
            addRoundFixtures(fixtures) {
                if (this.roundPredictions.length > 1) {
                    fixtures.forEach((fixture, index) => {
                        fixture.predictedWinningTeam = this.roundPredictions[index].PredictedWinningTeam;
                        fixture.winMargin = this.getWinMarginText(this.roundPredictions[index]);
                        this.roundFixtures.push(fixture);
                    });
                    this.predictions = this.roundPredictions;
                } else {
                    fixtures.forEach((fixture) => {
                        this.roundFixtures.push(fixture);
                    });
                }
            },
            async getRoundFixtures() {
                const response = await ScorePredictorService.getRoundFixtures(this.selectedRound.RoundID, this.userData.msisdn);
                this.addRoundFixtures(response.fixtures);
                this.setPointsScoringBreakdown(response.pointsScoringBreakdown);
            },
            clearState() {
                this.roundFixtures = [];
            },
        },
        mounted() {
            this.clearState();
            this.getRoundFixtures();
        }
    }
</script>

<style scoped lang="scss">
    .cricket-match {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        margin-bottom: 20px;
    }

    .win-margin-selector-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
        margin-right: 10px;
        margin-top: 30px;
    }

    .filler-box {
        background: none !important;
    }

    .win-margin-filler {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 5vh;
    }

    .win-margin-button {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 5vh;
        margin-top: 0.5rem;
        box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, .7),
        0 -0.25rem 1.5rem $tab-item-selected-color inset,
        0 0.75rem 0.5rem rgba(255, 255, 255, 0.4) inset,
        0 0.25rem 0.5rem 0 #b10505 inset;
        background-color: $tab-item-selected-color;
        border: none !important;
    }

    .warning-text {
        color: $tab-item-selected-color;
        margin: 0;
    }

    .how-to-earn-points-container {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: $icon-container-background-color;
        padding: 0.5rem 0;
        border-radius: 0 0 3px 3px;
        box-shadow: 4px 4px 4px black;
        margin-bottom: 0.5rem;
    }

    .how-to-earn-points-text {
        color: $heading-text-color;
    }

    .text-box {
        display: flex;
        justify-content: center;
        align-content: center;
        margin: 1vw;
        padding: 1vw;
    }

    .predictions-container {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        justify-content: center;
        align-content: center;
    }

    .prediction-box {
        position: absolute;
        justify-content: center;
        align-items: center;
        display: flex;
        width: 125px;
        height: 30px;
        background-color: white;
        border-radius: 0 0 3px 3px;
        bottom: -30px;
    }

    .prediction-completed-box {
        position: absolute;
        justify-content: center;
        align-items: center;
        display: flex;
        width: 125px;
        height: 30px;
        background-color: #67db61;
        border-radius: 0 0 3px 3px;
        bottom: -30px;
    }

    .match-box {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        align-items: stretch;
        margin-bottom: 20px;
    }

    .score-button-left {
        border-radius: 5px 0 0 5px;
    }

    .score-button-right {
        border-radius: 0 5px 5px 0;
    }

    .score-button {
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        background-color: $add-substract-score-background-color;
        height: 9vh;
    }

    .score-button:active {
        background-color: $add-substract-score-background-hover-color;
    }

    .score {
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        background-color: $score-predction-background-color;
        height: 9vh;
    }

    .generic-logo-team-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .generic-logo {
        height: 6vh;
    }

    .select-margin-text {
        color: $submit-button-red;
        margin-bottom: 0;
    }

    .cick-to-pick-text {
        color: #817c7c;
        margin-bottom: 0;
        opacity: 0.6;
    }

    .to-lose-text {
        color: black;
        margin: 0;
    }

    .generic-team-text {
        margin: 0;
        padding: 0;
        height: 2vh;
        font-size: small;
    }

    .win-margin-text {
        margin: 0;
        font-size: medium;
    }

    .team-img-box {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5px;
        height: 125px;
        width: 125px;
        margin-left: 10px;
        margin-right: 10px;
        border: solid 2px $team-icon-bored-color;
        border-radius: 5px 5px 0 0;
    }

    .submit-button-box {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 10px;
    }

    .submit-button {
        height: 10vh;
        margin-top: 10px;
        margin-bottom: 2vw;
        border-radius: 5px;
        background-color: $submit-button-red;
        width: 90%;
        border: none !important;
    }

    .team-logo {
        max-height: 90%;
        max-width: 90%;
    }

    .date-time {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 2vh;
    }

    .predictions-closed-box {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .score-number {
        color: $team-score-prediction-text-color;
        font-size: 6vh;
        margin: 0;
    }

    .vs-text-box {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0;
    }

    .vs-text {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0;
        padding: 0;
        color: $versus-text-color;
        font-size: large;
    }

    .description-text {
        z-index: 0;
        font-size: large;
    }

    .div-line-break {
        solid-color: $line-break-color;
        width: 80%;
    }

    .line-break {
        margin: 0;
        color: $line-break-color;
    }

    .line-break-matche-boxes {
        position: relative;
        bottom: -5vh;
    }

    .date-text {
        font-size: large;
        margin: 0;
        padding: 0;
    }

    .predictions-closed-text {
        font-size: large;
        color: red;
        padding: 0;
        margin-bottom: 1vh;
    }

    .button-text {
        color: white;
        font-size: large;
        margin: 0;
    }

</style>
